import React from "react";
import banner from "../../assets/projects/productaienrichment.png";
import ss1 from "../../assets/screenshots/dailybusinessreport/ss1.png"
import ss2 from "../../assets/screenshots/dailybusinessreport/ss2.png"
import ss3 from "../../assets/screenshots/dailybusinessreport/ss3.png"
import ss4 from "../../assets/screenshots/dailybusinessreport/ss4.png"
import ss5 from "../../assets/screenshots/dailybusinessreport/ss5.png"

const AIProductEnrichmentAutomationPage = () => (
  <main className="container mx-auto max-width pt-10 pb-20 space-y-16">

  {/* Banner Image */}
  <section className="w-full">
    <img
      src={banner}
      alt="AI Product Data Enrichment Automation Banner"
      className="w-[500px] rounded-xl shadow-md object-cover"
    />
  </section>

  {/* Project Title & Overview */}
  <section>
    <h1 className="text-4xl xl:text-5xl font-bold text-dark-heading dark:text-light-heading mb-4">
      AI Product Data Enrichment Automation
    </h1>
    <p className="text-lg text-content lg:max-w-4xl">
      AI Product Data Enrichment Automation is an AI-powered workflow that automatically enriches product data using large language models. Built with n8n, Airtable, and OpenAI, the system analyzes existing product information such as product title, description, brand, and category, and generates complete marketing and SEO-ready content. The generated data includes SEO titles, product descriptions, bullet points, keywords, benefits, use cases, and target audience insights. The automation reads product records from Airtable, processes them through an LLM chain, and updates the enriched data back into the Airtable database, significantly reducing manual product content creation work.
    </p>
  </section>

  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      ▶️ Live Demo
    </h2>
    <div className="w-full aspect-video">
      <iframe
        className="w-full h-full rounded-lg shadow"
        src="https://www.youtube.com/embed/S4Pots2Pc7k"
        title="AI Product Data Enrichment Automation Demo"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  </section>

  {/* Technology Stack */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      💻 Technology Stack
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li><strong>n8n:</strong> Workflow automation and orchestration of the product enrichment pipeline</li>
      <li><strong>Airtable:</strong> Stores product records and receives enriched product content updates</li>
      <li><strong>OpenAI (ChatGPT):</strong> LLM chain that generates structured product marketing content</li>
      <li><strong>n8n Form:</strong> Allows users to manually trigger enrichment for a specific product</li>
    </ul>
  </section>

  {/* AI Automation Features */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      🤖 AI Automation Features (n8n)
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>Automatically generates SEO-ready product content using AI</li>
      <li>Generates structured product marketing data fields</li>
      <li>Uses LLM chain to improve output quality based on product inputs</li>
      <li>Processes multiple product records automatically in batch</li>
      <li>Updates enriched product data back into Airtable</li>
    </ul>
  </section>

  {/* Generated Product Content */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      🧠 AI Generated Product Content
    </h2>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>SEO Title</li>
      <li>Full Product Description</li>
      <li>Bullet Points</li>
      <li>Short Description</li>
      <li>Keywords</li>
      <li>Value Proposition</li>
      <li>Benefits</li>
      <li>Product Summary</li>
      <li>Use Cases</li>
      <li>Target Audience</li>
    </ul>
  </section>

  {/* Automation Triggers */}
  <section>
    <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
      ⚙️ Automation Triggers
    </h2>

    <h3 className="text-2xl font-semibold mt-6 mb-2">Manual Batch Processing</h3>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>Searches Airtable for products with "pending" status</li>
      <li>Optional limit filter allows processing a specific number of records</li>
      <li>Loops through each product record</li>
      <li>Generates enriched product content using the AI LLM chain</li>
      <li>Updates the Airtable record with generated content</li>
      <li>Repeats until all selected records are processed</li>
    </ul>

    <h3 className="text-2xl font-semibold mt-6 mb-2">On-Demand Product Enrichment (n8n Form)</h3>
    <ul className="list-disc list-inside text-content space-y-2">
      <li>User submits a product ID through an n8n form</li>
      <li>The workflow searches Airtable for the specified product</li>
      <li>AI generates enriched content using the LLM chain</li>
      <li>The generated data is written back to Airtable for the selected product</li>
    </ul>
  </section>

  {/* Screenshots */}
  <section>
  <h2 className="text-3xl font-semibold text-dark-heading dark:text-light-heading mb-4">
    🖼️ Project Images & Screenshots
  </h2>
  <div className="flex flex-col gap-6">
  <div>
        <p className="mb-2 font-medium">Key Features</p>
        <a href={banner} target="_blank" rel="noopener noreferrer">
          <img src={banner} alt="AI Product Data Enrichment Automation" className="w-full rounded-lg shadow" />
        </a>
      </div>
    {/* <div>
      <p className="mb-2 font-medium">AI Product Enrichment Workflow (n8n)</p>
      <a href={ss1} target="_blank" rel="noopener noreferrer">
        <img src={ss1} alt="AI Product Enrichment Workflow" className="w-full rounded-lg shadow" />
      </a>
    </div>

    <div>
      <p className="mb-2 font-medium">Batch Processing of Pending Product Records</p>
      <a href={ss2} target="_blank" rel="noopener noreferrer">
        <img src={ss2} alt="Batch Processing Records" className="w-full rounded-lg shadow" />
      </a>
    </div>

    <div>
      <p className="mb-2 font-medium">LLM Chain Generating Product Marketing Content</p>
      <a href={ss3} target="_blank" rel="noopener noreferrer">
        <img src={ss3} alt="LLM Chain Generation" className="w-full rounded-lg shadow" />
      </a>
    </div>

    <div>
      <p className="mb-2 font-medium">Airtable Product Database with Enriched Fields</p>
      <a href={ss4} target="_blank" rel="noopener noreferrer">
        <img src={ss4} alt="Airtable Product Database" className="w-full rounded-lg shadow" />
      </a>
    </div> */}

  </div>
</section>

</main>
);

export default AIProductEnrichmentAutomationPage;
